import { useEffect, useState } from 'react';

import type { ResponsiveTableLayout } from './types';

/**
 * Hook che determina il layout della tabella in base al viewport.
 * Breakpoint allineati a Tailwind:
 *   - < lg (< 1024px) → 'sticky' (scroll orizzontale + colonne pinned)
 *   - ≥ lg (≥ 1024px) → 'full' (table-fixed + menu colonne)
 *
 * Layout 'card' disponibile solo via `forceLayout` (debug / opt-in).
 * SSR-safe: default 'full' se window non disponibile.
 */
export function useResponsiveLayout(force?: ResponsiveTableLayout): ResponsiveTableLayout {
  const compute = (): ResponsiveTableLayout => {
    if (force) return force;
    if (typeof window === 'undefined') return 'full';
    const w = window.innerWidth;
    if (w < 1024) return 'sticky';
    return 'full';
  };

  const [layout, setLayout] = useState<ResponsiveTableLayout>(compute);

  useEffect(() => {
    if (force) {
      setLayout(force);
      return;
    }
    const onResize = () => setLayout(compute());
    window.addEventListener('resize', onResize);
    // initial compute (in caso SSR hydrate)
    onResize();
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [force]);

  return layout;
}
